import './css/bootstrap.css'
import './css/main.css'
import React from 'react'
import { render } from 'react-dom'

import SankeyApp from './lib/SankeyApp'
import { convert_data } from 'open-sankey/dist/SankeyConvert'
import { SankeyData } from './lib/types'

window.React = React

type sous_filiere = { [ key : string ] : string }

declare const window: Window &
   typeof globalThis & {
    SankeyToolsStatic: boolean
    sankey: {
      sankey_data_file?:RequestInfo
      sous_filieres? : sous_filiere
      units?: string[],
      flask_logo? : string,
      flask_header? : string,
      logo_width? : number,
      excel? : string,
      filiere?: string,
      publish?: boolean,
      filiere_name: string,
      filiere2header: {[filiere_name:string]:string}
    }
   }

window.SankeyToolsStatic = window.SankeyToolsStatic === undefined ? false : window.SankeyToolsStatic

const data : SankeyData = {
  version: '0.5',
  file_path: 'sankey_diagram.json',
  node_width: 10,
  user_scale: 100,
  //height: 1500,
  width: 2150,
  h_space: 200,
  v_space: 100,

  left_shift: 0.4,
  right_shift: 0.5,
  max_shift: 0.2,

  legend_position: [0,0],

  trade_close_hspace: 50,
  trade_close_vspace: 20,  
  trade_hspace: 200,

  trade_left_shift: 0.45,
  trade_right_shift: 0.55,
  trade_max_shift: 0.2,  

  nodes: {},
  links: {},

  animation_tooltips: {},
  show_uncert: false,

  display_style : {
    font_size         : 11,
    sector_uppercase  : false,
    sector_bold       : false,
    sector_italic     : false,
    product_uppercase : false,
    product_bold      : false,
    product_italic    : false,
    unit              : false,
    filter            : 0,
    filter_label      : 0,
    global_curvature  : 0.5,
    null_flux: false
  },

  static_sankey  : window.SankeyToolsStatic,

  tags_catalog : {
    flux_types : {
      group_name : 'flux_types',
      show_legend: false,
      tags : {
        initial_data  : {name : 'Données collectées' , selected : false, color : ''},
        computed_data : {name : 'Données déterminées', selected : true, color : ''},
        adjusted_data : {name : 'Données réconciliées', selected : true, color : ''}
      },
      banner: 'multi'
    }
  },

  tooltip_names : [],

  tooltips: [],
  units_names: [],
  default_tooltip: true,

  tags_group_idx : 1,
  tag_idx: 1,
  node_idx: 1,
  link_idx: 1
}
 
if (!window.SankeyToolsStatic) {
  const json_data = localStorage.getItem('data')
  if (json_data !== null) {
    const new_data = JSON.parse(json_data)
    Object.assign(data, new_data)
    convert_data(data)
    data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false
  }
  render(
    <SankeyApp 
      initial_sankey_data={data} 
    />,
    document.getElementById('react-container')
  )
} else if (window.sankey && window.sankey.publish) {
  const logo_width = 200
  const header = window.sankey.filiere2header[window.sankey.filiere_name]
  //window.sankey.excel = window.sankey.filiere_name + '.xlsx'
  window.sankey.excel = 'ViandeFranceetRegionsTECetTonnes.zip'

  localStorage.setItem('data',JSON.stringify(window.sankey.filiere))
  const json_data = localStorage.getItem('data')
  if (json_data !== null && json_data !== 'undefined' ) {
    const new_data = JSON.parse(json_data)
    Object.assign(data, new_data)
    convert_data(data)
    data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false
  }
  render(
    <>
      <SankeyApp 
        initial_sankey_data={data}
      />
      <div id="copyright">
        <div className="container">
          <div className="row" style={{ 'marginTop' : '0px' }} >
            <div className="col-sm-11">
              <br/>
              <p>Réalisé par TerriFlux - <a href="https://terriflux.fr">www.terriflux.fr</a></p>
            </div>
            <div className="col-sm-1">
              <img src="logo_terriflux.jpg" width="100"/>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById('react-container')
  )
} else {
  if ( window.sankey == undefined ) {
    window.sankey = {
      sankey_data_file : '/fm/userfiles/Archives/Savoie/filiere_complete.json',
      units : ['k m3 fibre', 'Naturelles'],
      filiere_name: 'Filière forêt bois deux Savoies',
      filiere2header: {}
    }
  }
  const flask_logo = window.sankey.flask_logo
  const flask_header = window.sankey.flask_header
  const logo_width = window.sankey.logo_width
  if (window.sankey.sankey_data_file) {
    fetch(window.sankey.sankey_data_file)
      .then(res => res.json())
      .then((new_data)=>{
        new_data.file_path = window.sankey.sankey_data_file
        let result = JSON.stringify(new_data)
        result = result.split('<br>').join('\\\\n')
        new_data = JSON.parse(result)
        convert_data(new_data)
        new_data.static_sankey = true
        Object.assign(data, new_data)
        render(
          <>
            <div className="container">
              <div className="row">
                <div className="col-sm-4">
                  <br/>
                  <img src={flask_logo} width={logo_width}/>
                  <br/>
                </div>
                <div className="col-sm-8">
                  <br/>
                  <h2>{flask_header}</h2>
                  <br/>
                </div>
              </div>
            </div>
            <SankeyApp 
              initial_sankey_data={data}
            />
            <div id="copyright">
              <div className="container">
                <div className="row" style={{ 'marginTop' : '0px' }} >
                  <div className="col-sm-11">
                    <br/>
                    <p>Réalisé par TerriFlux - <a href="https://terriflux.fr">www.terriflux.fr</a></p>
                  </div>
                  <div className="col-sm-1">
                    <img src="/fm/userfiles/sankey_transparent.png" width="100"/>
                  </div>
                </div>
              </div>
            </div>
          </>,
          document.getElementById('react-container')
        )
      })
  }
}